<div>
  <app-pdf-viewer
    *ngIf="file?.stream"
    height="745px"
    [pdfSrc]="file.stream">
  </app-pdf-viewer>
</div>
<app-blocking-loader *ngIf="showBlockingLoader"></app-blocking-loader>
